// Third Party
import React from 'react';

// Components
import { CollapsibleContainer } from '../../misc';
import QuickAddList from './QuickAddList';
import QuickAddGICSimulator from './QuickAddGICSimulator';
import QuickAddHISASimulator from './QuickAddHISASimulator';

// Utils
import { formatLocalizedString } from '../../../../utils/i18n';
import User from '@/types/user';
import QuickAddItems from '@/types/quick-add-items';
import CustomYieldParams from '@/types/custom-yield-params';
import ShelvableInstrument from '@/types/shelvable-instrument';
import CompliantInstrument from '@/types/compliant-instrument';

type Props = {
  user: User;
  section: QuickAddItems;
  onAddFund: (id: string) => void;
  onAddCustomYield: (config: CustomYieldParams, shelfInfo: ShelvableInstrument & CompliantInstrument) => void;
  onOpenScreener: (proxyOption: string) => void;
};

enum QuickAddUIType {
  ItemList = 'ITEM_LIST',
  GICSimulator = 'GIC_SIMULATOR',
  HISASimulator = 'HISA_SIMULATOR',
}

class QuickAddContainer extends React.Component<Props> {
  renderQuickAddContent = () => {
    const { user } = this.props;
    const { section, onAddFund, onOpenScreener, onAddCustomYield } = this.props;

    switch (section.uiType) {
      case QuickAddUIType.ItemList: {
        return (
          <>
            {section.options.subSections &&
              section.options.subSections.map(subSection => (
                <QuickAddList
                  key={subSection.key}
                  sectionKey={subSection.key}
                  title={formatLocalizedString(subSection.displayName)}
                  items={subSection.items !== undefined ? subSection.items : []}
                  onAddFund={onAddFund}
                  onOpenScreener={onOpenScreener}
                />
              ))}

            {section.options.items && (
              <QuickAddList items={section.options.items !== undefined ? section.options.items : []} onAddFund={onAddFund} onOpenScreener={onOpenScreener} />
            )}
          </>
        );
      }
      case QuickAddUIType.GICSimulator: {
        return (
          <QuickAddGICSimulator
            user={user}
            benchmarkLipperId={section.options.benchmarkLipperId}
            onSubmit={onAddCustomYield}
            filteredShelves={section.filteredShelves}
            complianceComparisons={section.complianceComparisons}
          />
        );
      }
      case QuickAddUIType.HISASimulator: {
        return (
          <QuickAddHISASimulator
            user={user}
            benchmarkLipperId={section.options.benchmarkLipperId}
            onSubmit={onAddCustomYield}
            filteredShelves={section.filteredShelves}
            complianceComparisons={section.complianceComparisons}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  render() {
    const { section, ...rest } = this.props;
    return (
      <CollapsibleContainer defaultOpen={false} headerText={formatLocalizedString(section.displayName)} className="quick-add-container" noTextHover>
        {this.renderQuickAddContent()}
      </CollapsibleContainer>
    );
  }
}

export default QuickAddContainer;
